import React from 'react';
import { FaEnvelope, FaMapMarkerAlt, FaPhone, FaTiktok } from 'react-icons/fa';

const Contact = () => {
  const handleRedirect = () => {
    window.location.href = 'https://www.tiktok.com/@s_state_0?_r=1&_t=ZS-93to7uyf67I';
  };

  return (
    <section id="contact" className="py-5 bg-light">
      <div className="container">
        {/* العنوان */}
        <div className="text-center mb-5">
          <span className="badge bg-tiktok-cyan text-black px-3 py-2 mb-3">CONTACT</span>
          <h2 className="display-5 fw-bold mb-3">تواصل معنا</h2>
          <p className="lead text-secondary">
            عندك استفسار؟ اضغط على الزر عشان تتابعنا على TikTok
          </p>
        </div>

        <div className="row g-5">
          {/* معلومات الاتصال */}
          <div className="col-lg-6" data-aos="fade-right">
            <div className="bg-white p-4 rounded-4 shadow-sm">
              <h4 className="fw-bold mb-4">ابقى على تواصل</h4>

              {/* العنوان */}
              <div className="d-flex mb-4">
                <div className="bg-danger bg-opacity-10 p-3 rounded-3 me-3">
                  <FaMapMarkerAlt className="text-tiktok-cyan" style={{ fontSize: '24px' }} />
                </div>
                <div>
                  <h6 className="fw-bold">العنوان</h6>
                  <p className="text-secondary mb-0">
                    مكتبنا الرئيسي: راس الخيمة - الإمارات | القاهرة - مصر
                  </p>
                </div>
              </div>

              {/* البريد الإلكتروني */}
              <div className="d-flex mb-4">
                <div className="bg-danger bg-opacity-10 p-3 rounded-3 me-3">
                  <FaEnvelope className="text-danger" style={{ fontSize: '24px' }} />
                </div>
                <div>
                  <h6 className="fw-bold">البريد الإلكتروني</h6>
                  <p className="text-secondary mb-0">joof43438@gmail.com</p>
                </div>
              </div>

              {/* الهاتف */}
              <div className="d-flex mb-4">
                <div className="bg-danger bg-opacity-10 p-3 rounded-3 me-3">
                  <FaPhone className="text-tiktok-cyan" style={{ fontSize: '24px' }} />
                </div>
                <div>
                  <h6 className="fw-bold">الهاتف</h6>
                  <p className="text-secondary mb-0">01108570803</p>
                </div>
              </div>

              {/* تيك توك */}
              <div className="d-flex mb-4">
                <div className="bg-danger bg-opacity-10 p-3 rounded-3 me-3">
                  <FaTiktok className="text-tiktok-red" style={{ fontSize: '24px' }} />
                </div>
                <div>
                  <h6 className="fw-bold">تيك توك</h6>
                  <p className="text-secondary mb-0">
                    <a
                      href="https://www.tiktok.com/@s_state_0?_r=1&_t=ZS-93to7uyf67I"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none text-tiktok-red"
                    >
                      @s_state_0
                    </a>{' '}
                    (الحساب الأساسي)
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* زر التواصل المباشر */}
          <div className="col-lg-6" data-aos="fade-left" data-aos-delay="200">
            <div
              className="bg-white p-4 rounded-4 shadow-sm d-flex flex-column align-items-center justify-content-center"
              style={{ minHeight: '400px' }}
            >
              <FaTiktok className="text-tiktok-red mb-4" style={{ fontSize: '80px' }} />

              <h4 className="fw-bold mb-3">تواصل معنا مباشرة</h4>

              <p className="text-secondary text-center mb-4">
                أسرع طريقة للتواصل معانا هي عبر حسابنا الرسمي على TikTok.
                اضغط على الزر عشان تتابعنا وتبعتلنا رسالة.
              </p>

              <button
                onClick={handleRedirect}
                className="btn btn-danger btn-lg px-5 py-3 fw-bold text-white"
              >
                <FaTiktok className="me-2" />
                راسلنا على TikTok
              </button>
            </div>
          </div>
        </div>

        {/* صورة المكتب */}
        <div className="mt-5 text-center">
          <img
            src="https://images.unsplash.com/photo-1497215728101-856f4ea42174?w=1200"
            alt="Dubai office"
            className="img-fluid rounded-4 shadow"
            style={{ maxHeight: '300px', width: '100%', objectFit: 'cover' }}
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;
